import React, {Component} from 'react';
import PropTypes from 'prop-types';
import values from 'lodash/values';
import keyBy from 'lodash/keyBy';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import {Field, reduxForm} from 'redux-form';
import {RadioField} from './RadioField';
import {Alert, Button, Col, ControlLabel, Form, FormGroup} from 'react-bootstrap';
import {InputField} from './InputField';
import {validation} from '../validation';
import classNames from 'classnames';

const validate = validation({
    name: {
        required: true,
    },
});

@reduxForm({form: 'presetNumber', validate, enableReinitialize: true})
export default class PresetNumber extends Component {
    static propTypes = {
        selectedPresetNumber: PropTypes.number,
        presets: PropTypes.object.isRequired,
        initialValues: PropTypes.object, // this contains the actual data for this entity
        handleSubmit: PropTypes.func, // passed by redux-form
        onCancel: PropTypes.func,
        editableName: PropTypes.bool,
        showMatchingWarning: PropTypes.bool,
    };

    validateNameUnique = (name) => {
        const {presets} = this.props;
        if (!find(presets, {name})) {
            return null;
        }
        return `There is already a preset named "${name}"`;
    };

    render() {
        const {presets, handleSubmit, editableName, initialValues: {id, amplitude, spread}, onCancel, selectedPresetNumber, showMatchingWarning} = this.props;
        const presetsByNumber = keyBy(values(presets), 'presetNumber');
        const presetControls = [];
        for (let i = 1; i <= 9; ++i) {
            const iPreset = presetsByNumber[i];
            let presetLabel;
            if (iPreset) {
                presetLabel = (
                    <span
                        className={classNames('assigned', {current: id === iPreset.id})}
                    >
                        {`${i} - assigned to "${iPreset.name}" (a: ${iPreset.amplitude}, s: ${iPreset.spread})`}
                    </span>
                );
            } else {
                presetLabel = <span className="unassigned">{`${i} - unassigned`}</span>;
            }
            presetControls.push(
                <li key={i}>
                    <Field type="radio" name="presetNumber" component={RadioField} value={`${i}`} checked={selectedPresetNumber === i} inline>
                        {presetLabel}
                    </Field>
                </li>
            );
        }
        let warning;
        if (selectedPresetNumber >= 1 && presetsByNumber[selectedPresetNumber] && (!id || id !== presetsByNumber[selectedPresetNumber].id)) {
            warning = (
                <Alert bsStyle="warning">
                    {`${selectedPresetNumber} is already assigned to preset "${presetsByNumber[selectedPresetNumber].name}"`}
                </Alert>
            );
        }
        let matchingWarning;
        if (showMatchingWarning) {
            const matchingPresets = filter(presets, {amplitude, spread});
            if (!isEmpty(matchingPresets)) {
                matchingWarning = (
                    <Alert bsStyle="warning">
                        {`There is already a preset ("${matchingPresets[0].name}") with matching amplitude and spread`}
                    </Alert>
                );
            }
        }

        return (
            <Form onSubmit={handleSubmit} style={{margin: 'auto'}} horizontal className="preset-number">
                {matchingWarning}
                <Field type="text" name="name" component={InputField} label="Name" required={editableName} autoFocus={editableName} readOnly={!editableName} validate={this.validateNameUnique}/>
                <Field type="text" name="amplitude" component={InputField} label="Amplitude" readOnly/>
                <Field type="text" name="spread" component={InputField} label="Spread" readOnly/>
                <FormGroup>
                    <Col md={3} componentClass={ControlLabel}>{'Preset number'}</Col>
                    <Col md={9}>
                        <ul>
                            <li key={0}>
                                <Field type="radio" name="presetNumber" component={RadioField} value="" checked={!selectedPresetNumber} inline>
                                    <span className="unassigned">{'none'}</span>
                                </Field>
                            </li>
                            {presetControls}
                        </ul>
                    </Col>
                </FormGroup>
                {warning}
                <FormGroup>
                    <Col mdOffset={3} md={9}>
                        <Button type="submit" bsStyle="success">{'Submit'}</Button>
                        <Button bsStyle="link" onClick={onCancel}>{'Cancel'}</Button>
                    </Col>
                </FormGroup>
            </Form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PresetNumber.js